import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import CheckboxGroupField from "@saleor/components/CheckboxGroupField";
import Grid from "@saleor/components/Grid";
// import RadioGroupField from "@saleor/components/RadioGroupField";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
// import { getFormErrors } from "@saleor/utils/errors";
// import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import {
  DiscountDeliveryTypeEnum,
  VoucherClassificationEnum,
  VoucherTypeEnum
} from "../../../types/globalTypes";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherDeliveryTypeProps {
  data: VoucherDetailsPageFormData;
  errors: DiscountErrorFragment[];
  clientErrors?: {
    deliveryType?: string;
  };
  disabled: boolean;
  onChange: (event: ChangeEvent<any>) => void;
}

const VoucherDeliveryType = ({
  data,
  disabled,
  // errors,
  clientErrors,
  onChange
}: VoucherDeliveryTypeProps) => {
  const intl = useIntl();

  const deliveryTypeChoices = [
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.FOOD_AND_BEVERAGES ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      id: "nextDayCheckbox",
      label: intl.formatMessage({
        defaultMessage: "Standard Delivery",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.NEXT_DAY
    },
    {
      disabled:
        disabled ||
        data.discountType.toString() === "SHIPPING" ||
        data.type === VoucherTypeEnum.SHIPPING ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      id: "inStoreCheckbox",
      label: intl.formatMessage({
        defaultMessage: "In Store",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.IN_STORE
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.GENERAL_MERCHANDISE ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      id: "expressDeliveryCheckbox",
      label: intl.formatMessage({
        defaultMessage: "Express Delivery",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.EXPRESS_DELIVERY
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.GENERAL_MERCHANDISE ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      id: "expressLongDistanceDeliveryCheckbox",
      label: intl.formatMessage({
        defaultMessage: "Express Long-Distance Delivery",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.EXPRESS_LONG_DISTANCE_DELIVERY
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.GENERAL_MERCHANDISE ||
        data.verticalType === VoucherClassificationEnum.FOOD_AND_BEVERAGES,
      id: "nationwideDeliveryCheckbox",
      label: intl.formatMessage({
        defaultMessage: "Nationwide Delivery",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.NATIONWIDE_DELIVERY
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.FOOD_AND_BEVERAGES ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      label: intl.formatMessage({
        defaultMessage: "Same Day Delivery",
        description: "delivery type"
      }),
      value: DiscountDeliveryTypeEnum.SAME_DAY
    }
  ];

  const handleCheckboxChange = e => {
    const { checked, value } = e.target;
    if (checked) {
      const newArray = data.deliveryType;
      newArray.push(value);
      onChange({ target: { name: "deliveryType", value: newArray } });
    } else {
      const newArray = data.deliveryType.filter(item => item !== value);
      onChange({ target: { name: "deliveryType", value: newArray } });
    }
  };

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Delivery Type",
          description: "header"
        })}
      />
      <CardContent>
        <Grid variant="uniform">
          {/* <RadioGroupField
            choices={deliveryTypeChoices}
            disabled={
              disabled ||
              data.discountType.toString() === "E_VOUCHER" ||
              data.type.toString() === "E_VOUCHER"
            }
            name={"deliveryType" as keyof VoucherDetailsPageFormData}
            value={data.deliveryType}
            onChange={onChange}
          /> */}
          <CheckboxGroupField
            choices={deliveryTypeChoices}
            disabled={
              disabled ||
              data.discountType.toString() === "E_VOUCHER" ||
              data.type.toString() === "E_VOUCHER"
            }
            name={"deliveryType" as keyof VoucherDetailsPageFormData}
            value={data.deliveryType}
            onChange={handleCheckboxChange}
          />
        </Grid>
        {clientErrors && clientErrors.deliveryType && (
          <span style={{ color: "red" }}>{clientErrors.deliveryType}</span>
        )}
      </CardContent>
    </Card>
  );
};
export default VoucherDeliveryType;
